export default __webpack_public_path__ + "static/media/006-left turn.e8bd0364.png";